import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrivateShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.714 1.08843C11.9037 1.06102 12.0964 1.06102 12.2861 1.08843C12.5047 1.12002 12.7081 1.19688 12.8697 1.2579L12.9129 1.27422L18.4054 3.33374C19.0232 3.56439 19.5657 3.76694 19.9835 4.13517C20.349 4.45729 20.6306 4.86358 20.8039 5.31893C21.0019 5.83944 21.0011 6.41855 21.0002 7.07799L21 11.9999C21 14.8265 19.4627 17.1831 17.801 18.9143C16.1281 20.6571 14.214 21.888 13.2019 22.4785L13.1609 22.5025C12.9762 22.611 12.7365 22.7517 12.4194 22.8198C12.1599 22.8754 11.8401 22.8754 11.5807 22.8198C11.2635 22.7518 11.0238 22.611 10.8391 22.5025L10.7981 22.4785C9.78602 21.888 7.87198 20.6571 6.19908 18.9143C4.53731 17.1831 3.00002 14.8265 3.00002 11.9999L2.99989 7.078C2.99893 6.41856 2.99809 5.83944 3.19616 5.31893C3.36943 4.86358 3.65099 4.45729 4.01651 4.13517C4.43433 3.76695 4.97687 3.56439 5.59466 3.33374L11.0871 1.27422L11.1304 1.2579C11.2919 1.19688 11.4954 1.12002 11.714 1.08843ZM16.2071 9.70711C16.5976 9.31658 16.5976 8.68342 16.2071 8.29289C15.8166 7.90237 15.1834 7.90237 14.7929 8.29289L11 12.0858L9.70711 10.7929C9.31658 10.4024 8.68342 10.4024 8.29289 10.7929C7.90237 11.1834 7.90237 11.8166 8.29289 12.2071L10.2929 14.2071C10.6834 14.5976 11.3166 14.5976 11.7071 14.2071L16.2071 9.70711Z",
			fill: "url(#paint0_linear_237_12996)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2071 9.70717C16.5976 9.31664 16.5976 8.68348 16.2071 8.29295C15.8166 7.90243 15.1834 7.90243 14.7929 8.29295L11 12.0858L9.70711 10.793C9.31658 10.4024 8.68342 10.4024 8.29289 10.793C7.90237 11.1835 7.90237 11.8166 8.29289 12.2072L10.2929 14.2072C10.6834 14.5977 11.3166 14.5977 11.7071 14.2072L16.2071 9.70717Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_237_12996",
			x1: 12,
			y1: 1.06787,
			x2: 12,
			y2: 22.8615,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF537F" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#641EDC"
			})]
		}) })
	]
});
export default SvgPrivateShield;
